import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class StandardRoomI18nCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	// 基本設定
	public base = createFeatureIslandCategoryStore({
		title: "部屋名・画像",
		description: "部屋に関する基本的な設定を行う項目です",
		isBasicSetup: true,
	});

	// ここから下は 「追加設定」isBasicSetup: false
	public address = createFeatureIslandCategoryStore({
		title: "部屋ごとの住所",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [this.base, this.address];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const standardRoomI18nCategoriesAndManagerStore = new StandardRoomI18nCategoriesAndManagerStore();
